// extracted by mini-css-extract-plugin
export default {"charts":"StatsContent_charts__gpm+n"};